/**
 * @ngdoc directives
 * @memberof mercury.modules.time
 * @name timerange
 */
angular.module('mercury.modules.time.roster')
.directive('menushowhide', function() {
  return {
    restrict: 'A',
    link: function($scope) {
      $scope.currentStatus = 'open';

      $scope.toggle = function() {
        if ($scope.currentStatus == 'open') {

          // Push the top nav off the screen so the full height is used by the roster editor
          $('.navbar-fixed-top')[0].style.setProperty('top', '-100px', 'important');

          // Hide the sidebar so the overall page background shows through everywhere
          $('#sidebar-wrapper #main-sidenav')[0].style.setProperty('display', 'none');

          // Adjust the main content area to fill the whole page
          $('#page-content-wrapper')[0].style.setProperty('margin-left', '0', 'important');
          $('#page-content-wrapper')[0].style.setProperty('padding-top', '0', 'important');

          $scope.currentStatus = 'closed';
        } else {

          // Reverse the changes made when forcing full screen
          $('.navbar-fixed-top')[0].style.removeProperty('top');
          $('#sidebar-wrapper #main-sidenav')[0].style.removeProperty('display');
          $('#page-content-wrapper')[0].style.removeProperty('margin-left');
          $('#page-content-wrapper')[0].style.removeProperty('padding-top');

          $scope.currentStatus = 'open';
        }
      }

    }
  };
});
